import { createFileRoute } from '@tanstack/react-router';
import { useRegistrationGuard } from '@/hooks/use-registration-guard';
import { STEPS } from '@/features/cleaner/apply-cleaner/constant';
import { CompletedStep } from '@/features/cleaner/apply-cleaner/steps/completed-step';

function CompletedRoute() {
  useRegistrationGuard({
    requiredStep: STEPS.COMPLETED,
    requireAuth: true,
    redirectTo: '/apply-cleaner/background-check',
    allowCompleted: true,
  });

  return <CompletedStep />;
}

export const Route = createFileRoute('/(cleaner)/apply-cleaner/completed')({
  component: CompletedRoute,
});
